import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Coupon } from '../../../shared/interfaces/coupon';
import { PaymentSuffixPipe } from '../../../shared/pipes/payment-suffix.pipe';
import { Sale } from '../../../shared/interfaces/sale';

@Component({
    selector: 'app-coupon-summary',
    standalone: true,
    imports: [CommonModule, PaymentSuffixPipe],
    templateUrl: './coupon-summary.component.html',
    styleUrl: './coupon-summary.component.scss',
})
export class CouponSummaryComponent {
    @Input({ required: true }) public coupon: Coupon | undefined;

    @Input({ required: true }) public sale!: Sale;

    @Input() public valueOverride: number | undefined;
}
